import { Form, InputNumber, Switch } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import type { OptionsAPI } from '../useOptions'

const KEYS = [
  'QuotaForNewUser',
  'PreConsumedQuota',
  'QuotaForInviter',
  'QuotaForInvitee',
  'quota_setting.enable_free_model_pre_consume',
]

export default function CreditSection({ options }: { options: OptionsAPI }) {
  const { getNumber, getBool, patch } = options

  return (
    <SettingSectionCard title="额度设置" subtitle="新用户、邀请与预消耗" keys={KEYS} options={options}>
      <Form layout="vertical">
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="新用户初始额度">
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              value={getNumber('QuotaForNewUser')}
              onChange={(v) => patch({ QuotaForNewUser: v ?? 0 })}
            />
          </Form.Item>
          <Form.Item label="预消耗额度">
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              value={getNumber('PreConsumedQuota')}
              onChange={(v) => patch({ PreConsumedQuota: v ?? 0 })}
            />
          </Form.Item>
          <Form.Item label="邀请人奖励额度">
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              value={getNumber('QuotaForInviter')}
              onChange={(v) => patch({ QuotaForInviter: v ?? 0 })}
            />
          </Form.Item>
          <Form.Item label="被邀请人奖励额度">
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              value={getNumber('QuotaForInvitee')}
              onChange={(v) => patch({ QuotaForInvitee: v ?? 0 })}
            />
          </Form.Item>
          <Form.Item label="免费模型预消耗">
            <Switch
              checked={getBool('quota_setting.enable_free_model_pre_consume', true)}
              onChange={(v) => patch({ 'quota_setting.enable_free_model_pre_consume': v })}
            />
          </Form.Item>
        </div>
      </Form>
    </SettingSectionCard>
  )
}
